import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Editor as H4Editor } from "../H1Block/Editor";
import { H4 } from "./H4Block";
import { defaultData } from "./H4BlockDefaultData";
import { meta } from "./H4BlockMetaData";

export const H4Block: BlockExport = {
  type: "component",
  Block: H4,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-heading",
    size: 24,
  },
  Editor: H4Editor,
  defaultData,
  meta,
};
